var _dec, _class2, _descriptor;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

import { guidFor } from '@ember/object/internals';
import { inject } from '@ember/service';
import Component from '@glimmer/component';

let _class = (_dec = inject('ember-elsewhere'), (_class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "service", _descriptor, this);
  }

  get sideEffect() {
    if (this.args.name) {
      throw new Error(`to-elsewhere takes a "named=" parameter, not "name="`);
    }

    this.service.show(guidFor(this), this.args.named, this.args.send, this.args.outsideParams, this.args.order);
    return undefined;
  }

  willDestroy() {
    super.willDestroy();
    this.service.clear(guidFor(this));
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "service", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2));

export { _class as default };